import React from 'react';
import '../styles/solutions.css';
import image from '../assets/solutions.png';

const Solutions= () => {

    return(
        <div className='solutions'>
            <h4 style={{color:'#FFD52B'}}>Service & Solution Categories</h4>
            <hr></hr>
            <div className="row pt-4">
            <div className="col-12 col-md-6  text-white text-left solutions-box1">
                <h1  style={{fontWeight:'600'}}>System Concepts</h1>
                <p style={{color:'white',fontSize:'0.9rem',width:'90%'}}>Strategic planning and design of modular robotic systems customized for your business needs.</p>
                {/* <img src={image} width='100%' ></img> */}
            </div>
            <div className="col-12 col-md-6 solutions-box2 ">
                 
            <div className="row">
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>01</h1>
            </div>
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Hardware Planning in EPLAN</h4>
                <p style={{color:'white',fontSize:'0.9rem',width:'90%'}} >Comprehensive hardware planning with EPLAN for efficient and optimized system architecture.</p>
                
            </div>
            </div>
            <div className="custom-dashed-line"></div>

            <div className="row sol-col-rev">
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Custom Software Development</h4>
                <p style={{color:'white',fontSize:'0.9rem',width:'90%'}} >Tailored software solutions for seamless robotic integration and advanced automation.</p>
                
            </div>
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>02</h1>
            </div>
            
            </div>
            <div className="custom-dashed-line"></div>
            <div className="row">
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>03</h1>
            </div>
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>PLC and SCADA Programming</h4>
                <p style={{color:'white',fontSize:'0.9rem',width:'90%'}} >Programmable controllers and SCADA systems for robust process control and monitoring</p>
                
            </div>
            </div>
            <div className="custom-dashed-line"></div>
            <div className="row sol-col-rev">
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Turnkey Project Management</h4>
                <p style={{color:'white',fontSize:'0.9rem',width:'90%'}} >End-to-end project solutions, from planning to deployment, ensuring success at every stage..</p>
                
            </div>
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>04</h1>
            </div>
            
            </div>
            </div>
        </div>

        </div>
    );
}

export default Solutions;